<template>
    <div class="AssemblyQuantityFormComponent">

        
        {{lang.label_Quantity}}:
        <b-form-input size="sm" class="form-control" v-model="form.quantity" type="number"
            aria-describedby="input-Quantity-feedback" :state="validation_Quantity"></b-form-input>
        <b-form-invalid-feedback id="input-Quantity-feedback" :state="validation_Quantity">
            {{lang.validinfo_Quantity}}
        </b-form-invalid-feedback>
        <br>
  


    </div>
</template>

<script>


export default {
    name: "AssemblyQuantityFormComponent",
    components: {



    },
    props: {
        lang: Object,
        
    },
    data() {
        return {
            form: {
                quantity: 1,
              

            },

        }
    },
    computed: {
        validation_Quantity() {

            return (this.form.quantity > 0) && ((this.form.quantity % 1) == 0);
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        
    },
    created() {

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_assemblyQuantityForm", this.form);

    },
    updated() {

        this.form.quantity = parseInt(this.form.quantity);
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_assemblyQuantityForm", this.form);

    },
    watch: {
        
    },
    methods: {
        
    }
}
</script>
<style lang="scss">
.AssemblyQuantityFormComponent {

}
</style>



// WEBPACK FOOTER //
// src/components/shared/AssemblyQuantityFormComponent.vue